module.exports = __webpack_public_path__ + "img/assignment.fbc1a27f.svg";